import React from 'react'
import Slider from 'react-slick'
import ReelVideo from '@components/common/ReelVideo/ReelVideo'
import { IStreamingVideo } from 'app/_components/ContentfulPage/contentfulPage.types'
import { PostOrPage } from '@tryghost/content-api'
import { WildImageMobile } from '../InTheWild.utils'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const sliderSettings = {
  dots: false,
  arrows: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: true,
  variableWidth: true,
  swipeToSlide: true,
  className: 'pb-0',
  responsive: [
    {
      breakpoint: 640,
      settings: {
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
}

export function InTheWildMobile({
  posts,
  videos,
}: {
  posts: Partial<PostOrPage>[] | []
  videos: IStreamingVideo[]
}) {
  return (
    // @ts-ignore
    <Slider {...sliderSettings}>
      {videos?.map((video) => (
        <ReelVideo
          playbackId={`${video?.video?.playbackId}`}
          title={video?.title}
          wrapperClassName="w-[235px] h-[235px] m-2"
          videoClassName="rounded-xl object-cover"
          playsInline={false}
          key={video?.title}
        />
      ))}

      {posts.map((post: PostOrPage) => (
        <WildImageMobile
          imageClassName="rounded-xl object-cover m-2 w-[235px] h-[235px]"
          imgSrc={post?.feature_image}
          imgSlug={post?.slug}
          key={post?.slug}
        />
      ))}
    </Slider>
  )
}
